import { all, call, put, takeEvery } from "redux-saga/effects";

import {
  getDetailEventFailed,
  getDetailEventStart,
  getDetailEventSuccess,
} from "../redux/getDetailEvent";

import { getDetailEventsApi } from "core/http/service/internalEvents";

function* getDetailEventWork(action: ReturnType<typeof getDetailEventStart>) {
  const { eventId } = action.payload;

  try {
    const res = yield call(getDetailEventsApi, {
      eventId,
    });

    yield put({
      type: getDetailEventSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getDetailEventFailed.type,
    });
  }
}

function* watchGetDetailEvent() {
  yield takeEvery(getDetailEventStart.type, getDetailEventWork);
}

export default function* getDetailEventSaga() {
  yield all([watchGetDetailEvent()]);
}
